<template>
  <div class="row">
    <div class="col-md-12">
      <card :title="cardTitle" body-class="hidden">
        <template slot="buttons">
          <template v-if="isFileQueueActive">
            <button type="button" class="btn btn-primary" v-on:click="pickPrev" :disabled="isFirstFile"><i class="fa fa-chevron-left"></i> {{ $t('Action.prev') }}</button>
            <button type="button" :class="['btn', {'btn-primary': !selectionConfirmed, 'btn-success': selectionConfirmed}]" :disabled="!selectionConfirmed" v-on:click="pickNext" v-show="!isLastFile">{{ $t('Action.next') }} <i class="fa fa-chevron-right"></i></button>
            <button type="button" class="btn btn-success" v-show="isLastFile" :disabled="!selectionConfirmed" v-on:click="pickAndSave"><i class="fa fa-check"></i> {{ $t('Action.finish') }}</button>
          </template>
          <template v-else>
            <button type="button" class="btn btn-success" v-show="selectionConfirmed" v-on:click="save"><i class="fa fa-check"></i> {{ $t('Action.finish') }}</button>
          </template>
        </template>
      </card>
      <card>
        <template v-if="!uploadComplete">
          <fileuploader
            :file-message="$t('File.messageUpload')"
            :url="renderdUrl"
            :max-filesize="maxFilesize"
            param-name="attachment"
            accepted-files=".stl"
            no-progressbar
            @complete="showStl"
            @status="updateUploadStatus"
            @progress="updateUploadProgress"
            :append-token="true"
            :progress="uploadProgress"
            :status="uploadStatus"
            :active="uploadStatus == 'complete'"
          ></fileuploader>
        </template>
        <div v-for="(file, name) in files" v-show="file.complete">
          <h3 class="filename">{{ name }}</h3>
          <progressbar
            v-show="!file.complete"
            :progress="file.progress"
            :active="file.active"
          ></progressbar>
          <imagelist
            :images="file.images"
            :base-url="imageUrl(file)"
            :filter="$root.imageFilter"
            :limit="4"
          >
          </imagelist>
        </div>
      </card>
      <template v-if="uploadComplete">
        <card v-if="hasMultipleFiles && !isSameMaterialConfirmed" :title="$t('ProjectDetails.materialSelection')" class="mtop-10">
          <template slot="buttons">
            <button type="button" class="btn btn-success" v-on:click="setPickingMode(isSameMaterialValue)">{{ $t('Action.next') }} <i class="fa fa-chevron-right"></i></button>
          </template>
          <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 center ptop-10 pbottom-20">
            <field
              :label="$t('File.allFilesSameMaterial')"
              type="switch"
              :value="isSameMaterialValue"
              :default-value="true"
              v-on:input="updatePickingValue"
              label-class="col-lg-7 col-md-8 col-sm-9 col-xs-9"
              field-class="col-lg-5 col-md-4 col-sm-3 col-xs-3"
            ></field>
          </div>
        </card>
        <card v-if="!hasMultipleFiles || isSameMaterial" :title="materialTitle" class="mtop-10" :body-class="{'hidden': selectionConfirmed}">
          <template slot="buttons">
            <button v-if="selectionConfirmed" type="button" class="btn btn-primary" v-on:click="revertSelection"><i class="fa fa-repeat"></i> {{ $t('Action.changeSelection') }}</button>
            <button v-if="!selectionConfirmed" :disabled="!productSelected" type="button" class="btn btn-success" v-on:click="confirmSelection"><i class="fa fa-edit"></i> {{ $t('Action.confirmSelection') }}</button>
          </template>
          <finder
            v-if="!selectionConfirmed"
            :tree="productTree"
            :selection="selection"
            frame-classes="col-md-4 col-sd-4 col-xs-4"
            v-on:clickchild="selectProduct"
          ></finder>
        </card>
      </template>
    </div>
    <template v-if="selectionConfirmed">
      <div class="col-lg-7 col-md-6 col-sm-12">
        <card :title="$t('Configurator.setProductProps')" :refresh="updatePrices">
          <form class="form form-horizontal">
            <field
              v-for="(field, name) in form"
              label-class="col-md-12 col-sm-12 col-xs-12"
              field-class="col-md-12 col-sm-12 col-xs-12"
              :name="name"
              :label="$root.getLabelText(field.label)"
              :type="fieldType(field)"
              :maxlength="field.maxlength"
              :default-value="field.defaultValue"
              :check-value="field.itemnum"
              :options="field.options"
              :required="field.required"
              :tooltip="field.tooltip ? $t(field.tooltip) : undefined"
              v-if="meetsRequirements(field)"
              v-model="formValues[name]"
              v-on:input="updatePrices"
            ></field>
          </form>
        </card>
      </div>
      <div class="col-lg-5 col-md-6 col-sm-12">
        <card :title="$t('Common.itemPrice')" body-class="no-padding table-responsive" :loader="loadingPrice">
          <cart
            :items="cart.items"
            :netamount="cart.netamount"
            :tax="cart.tax"
            :total="cart.total"
            :show-prices="showPricesGlobal"
          ></cart>
        </card>
      </div>
      <div class="col-md-12 col-sm-12" v-if="!isFileQueueActive">
        <card :title="$t('Action.confirmSelection')" body-class="hidden">
          <template slot="buttons">
            <button type="button" class="btn" v-on:click="backToDetails"><i class="fa fa-chevron-left"></i> {{ $t('Action.prev') }}</button>
            <button type="button" class="btn btn-success" v-on:click="save"><i class="fa fa-check"></i> {{ $t('Action.finish') }}</button>
          </template>
        </card>
      </div>
    </template>
    <template v-if="isFileQueueActive">
      <div class="col-md-12">
        <card :title="fileCountTitle" body-class="hidden">
          <template slot="buttons">
            <button type="button" class="btn btn-primary" v-on:click="pickPrev" :disabled="isFirstFile"><i class="fa fa-chevron-left"></i> {{ $t('Action.prev') }}</button>
            <button type="button" :class="['btn', {'btn-primary': !selectionConfirmed, 'btn-success': selectionConfirmed}]" :disabled="!selectionConfirmed" v-on:click="pickNext" v-show="!isLastFile">{{ $t('Action.next') }} <i class="fa fa-chevron-right"></i></button>
            <button type="button" class="btn btn-success" v-show="isLastFile" :disabled="!selectionConfirmed" v-on:click="pickAndSave"><i class="fa fa-check"></i> {{ $t('Action.finish') }}</button>
          </template>
        </card>
      </div>
    </template>
  </div>
</template>
<script>
import Finder from '../Elements/Finder.vue';
import ProductPickerMixin from '../Mixins/ProductPicker.js';
import FormsMixin from '../Mixins/Forms.js';

var view = require('../view.js'),
    viewData = {
      images: [],
      frames: [],
      selection: [],
      selectionConfirmed: false,
      productSelected: false,
      isSameMaterial: null,
      isSameMaterialValue: true, // Checkbox value (unconfirmed)
      requireAttachments: [],
      itemnums: [],
      properties: [],
      formValues: {},
      maxunits: 0,
      files: {},
      fileIndex: 0,
      fileQueue: [],
      uploadStatus: 'idle',
      fileCount: 0,
      uploadCount: 0,
      uploadProgress: 0,
      uploadMessage: '',
      uploadError: '',
      loadingPrice: '',
      maxFilesize: 200,
      allowMultiple: true,
      cart: {}
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  mixins: [ ProductPickerMixin, FormsMixin ],
  components: {
    finder: Finder
  },
  props: {
    projectId: {},
    productTree: {}
  },
  computed: {
    isSameMaterialConfirmed() {
      return this.isSameMaterial != null;
    },
    materialTitle() {
      var title = this.$t('ProjectDetails.materialSelection');

      if (this.selectionConfirmed) {
        return title + ': ' + this.getMaterialSelection();
      }

      return title;
    },
    btnConfirmProductDisabled() {
      return viewData.selection == null;
    },
    cardTitle() {
      if (this.uploadComplete) {
        if (this.selectionConfirmed)
          return this.$t('Configurator.setProductProps');
        else
          return this.$t('Configurator.selectProduct');
      }

      return this.$t('Configurator.uploadStl');
    },
    hasMultipleFiles() {
      return this.fileCount > 1;
    },
    uploadComplete() {
      return this.fileCount > 0 && this.fileCount == this.uploadCount;
    },
    fileCountTitle() {
      return this.$t('Configurator.fileXofY', {x: this.fileIndex + 1, y: this.fileQueue.length});
    },
    isFileQueueActive() {
      return this.fileQueue.length > 0;
    },
    isFirstFile() {
      return this.fileQueue.length > 0 && this.fileIndex == 0;
    },
    isLastFile() {
      return this.fileQueue.length > 0 && viewData.fileIndex == this.fileQueue.length - 1;
    },
    renderdUrl() {
      return this.$root.url + 'project/' + this.projectId + '/part/';
    },
    showPricesGlobal() {
      return typeof this.$parent.$parent.currentUser.hidePrices == null ? true : !this.$parent.$parent.currentUser.hidePrices;
    }
    // FormsMixin - productFilter()
    // ProductPickerMixin - form()
  },
  mounted() {
    if (this.productFilter.length == 0) {
      return;
    }

    // console.log(filter);

    this.getFilteredTree(this.productTree, this.productFilter);
  },
  methods: {
    // ProductPickerMixin - revertSelection()
    // ProductPickerMixin - updateSelection(selection)
    // ProductPickerMixin - collectProperties(selection, property)
    // ProductPickerMixin - getItems(fileCount)
    getBranch() {
      // Retrieves the modelTree as main branch for ProductPickerMixin->collectProperties
      return this.productTree;
    },
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          viewData[i] = resetData[i];
        }
      }
      viewData.selection = [];
      viewData.formValues = {};
      viewData.files = {};
      viewData.fileQueue = [];
      viewData.frames = [ this.productTree ];
      viewData.properties.push(this.productTree.properties);
    },
    getFileList(selection) {
      var files = [];
      Object.keys(this.files).forEach(function(name) {
        // Clone the object
        files.push({
          name: name,
          fileType: 'stl',
          fileHash: this.files[name].fileHash,
          itemnums: this.getItems(),
          imageUrl: this.imageUrl(this.files[name]),
          missingRequirements: [],
          requireAttachments: JSON.parse(JSON.stringify(this.requireAttachments)),
          formValues: JSON.parse(JSON.stringify(this.formValues)),
          selection: JSON.parse(JSON.stringify(this.selection)),
          images: JSON.parse(JSON.stringify(this.files[name].images))
        });
      }.bind(this));
      return files;
    },
    updatePickingValue(checked) {
      viewData.isSameMaterialValue = checked;
    },
    setPickingMode(isSameMaterial) {
      viewData.isSameMaterial = isSameMaterial == true;
      if (!isSameMaterial) {
        this.startPickingQueue();
      }
    },
    startPickingQueue() {
      viewData.fileQueue = this.getFileList();
      this.pickFile(0, this.isSameMaterial);
    },
    pickFile(index, selectionConfirmed) {
      viewData.fileIndex = index;
      this.load(viewData.fileQueue[index], selectionConfirmed);
    },
    pickNext() {
      var files = this.getFileList();
      this.fileQueue[this.fileIndex] = files.pop();

      // Get the file values from the last frame
      var formValues = JSON.parse(JSON.stringify(this.fileQueue[viewData.fileIndex].formValues));
      if (typeof formValues.units != 'undefined') {
        delete formValues.units;
      }
      this.fileQueue[viewData.fileIndex + 1].formValues = formValues;

      this.pickFile(viewData.fileIndex + 1, this.isSameMaterial);
    },
    pickPrev() {
      this.pickFile(viewData.fileIndex - 1, true);
    },
    pickAndSave() {
      var files = this.getFileList();
      this.fileQueue[this.fileIndex] = files.pop();
      this.save();
    },
    checkForm() {
      for (var key in this.form) {
        if (
          this.form.hasOwnProperty(key)
          && (typeof this.form[key].required != 'undefined')
          && this.form[key].required
          && this.meetsRequirements(this.form[key])
          && (
            (typeof this.formValues[key] == 'undefined')
            || this.formValues[key] == null
            || this.formValues[key] == ''
          )
        ) {
          alert(this.$t('Common.errorFieldMissing', {field: this.$t(this.form[key].label)}));
          return false;
        }
      }

      return true;
    },
    save() {
      if (!this.checkForm()) {
        return;
      }

      this.$emit('save', this.isFileQueueActive ? this.fileQueue : this.getFileList());
    },
    load(file, selectionConfirmed) {
      // console.log('load', file, selectionConfirmed);
      this.fileCount = 1;
      this.uploadCount = 1;
      file.complete = true;
      file.active = true;
      file.progress = 100;
      file.status = 'complete';
      this.files = {};
      this.files[file.name] = file;

      // this.itemnums = file.itemnums;

      this.updateSelection(file.selection);
      this.selectionConfirmed = selectionConfirmed ? file.selection.length > 0 : false;
      this.productSelected = true;
      this.formValues = typeof file.formValues == 'undefined' ? {} : file.formValues;

      this.updatePrices();
    },
    imageUrl(file) {
      return this.renderdUrl + file.fileHash + (file.token ? ':' + file.token: '');
    },
    imageCount(file) {
      return file.images.length;
    },
    setFileHash(name, hash) {
      viewData.files[name].fileHash = hash;
      return viewData.files[name];
    },
    async showStl(fileuploader, file) {
      console.log('here', file);
      if (!(file && file.xhr && file.xhr.status >= 200 && file.xhr.status < 300 && file.hash)) {
        viewData.uploadError = this.$t('Common.errorUploadInvalidResp');
        return
      }

      const stlFile = this.setFileHash(file.name, file.hash);
      stlFile.active = true;
      // console.log(stlFile);
      // console.log('Chcking ', this.renderdUrl + stlFile.fileHash);

      let checkTimeout = 5000,
              checkMaxTries = 3;

      let result;
      while (checkMaxTries > 0) {
        try {
          const {data} = await this.$http.get(this.renderdUrl + stlFile.fileHash);
          ({result} = data);

          if (typeof result === 'object') {
            const {status} = result;
            if (parseInt(status, 10) === 2) {
              stlFile.complete = true;
              stlFile.images = [];
              if (result && result.meta && Array.isArray(result.meta.images)) {
                stlFile.images = result.meta.images;
              }
            }
            viewData.uploadStatus = 'Complete';
            viewData.uploadCount++;
            return;
          }
        } catch (e) {
          console.error(e);
        }

        checkMaxTries--;
        await new Promise(r => setTimeout(r, checkTimeout));
      }

      if (checkMaxTries === 0) {
        viewData.uploadStatus = 'error';
        viewData.uploadError = 'Server Error: ' + result.error;
      }

    },
    confirmSelection() {
      // When a product is selected and the uploader has multiple files with
      // the option "same material" and no active file queue, start a new file queue
      // with the selected material
      if (this.hasMultipleFiles
          && this.isSameMaterial
          && !this.isFileQueueActive) {

        this.startPickingQueue();
        return;
      }

      viewData.selectionConfirmed = true;
      viewData.formValues = {};
      this.updatePrices();
    },
    updateUploadProgress(progress, file) {
      viewData.uploadProgress = progress;
      this.addFile(file).progress = progress;
    },
    updateUploadStatus(status, file) {
      viewData.uploadStatus = status;

      if (typeof file == 'object') {
        this.addFile(file).status = status;
      }
    },
    addFile(file) {
      if (typeof viewData.files[file.name] == 'undefined') {
        viewData.fileCount++;
        viewData.files[file.name] = {
          progress: 0,
          status: 'sending',
          fileHash: null,
          images: []
        }
      }
      viewData.files[file.name].file = file;
      return viewData.files[file.name];
    },
    getMaterialSelection(selection) {
      if (typeof selection == 'undefined') {
        selection = this.selection;
      }
      var labels = this.collectProperties(selection, 'label');
      labels.shift();

      let localizedLabels = [];
      labels.forEach((l) => {
        localizedLabels.push(this.$root.getLabelText(l));
      });

      return localizedLabels.join(' › ');
    },
    backToDetails() {
      this.$emit('goback');
    },
    updatePrices() {
      viewData.loadingPrice = this.$t('Configurator.calcPrice');
      this.$http.post(this.$root.url + 'cart/', {
        items: this.getItems(this.fileCount),
        flat: 1,
        locale: this.$i18n.locale
      }).then(function(res) {
        viewData.loadingPrice = '';
        viewData.cart = res.data.result;
      }.bind(this));
    }
  }
});
</script>
